// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"9f1196dc","239":"3bca2f5c","667":"9a9e09f3","977":"6624d027"}[chunkId] + ".chunk.js";
};